<button class="close-button" mat-icon-button aria-label="close dialog" (click)="bottomSheetRef.dismiss()">
  <mat-icon>close</mat-icon>
</button>

<div class="font-control-container">

  @if (data.fontSizeEnabled !== false) {
    <div style="margin-top: 8px;">
      <div style="margin-bottom: 4px;">{{labelFontSize}}: {{data.currentFontSize}}</div>
      <mat-slider discrete
                  [min]="data.fontSizeMin ?? data.min ?? 8"
                  [max]="data.fontSizeMax ?? data.max ?? 100"
                  [step]="1"
      >
        <input #slider matSliderThumb [(ngModel)]="data.currentFontSize" (ngModelChange)="onFontSizeSliderChange()" />
      </mat-slider>
    </div>
  }

  @if (data.linesPerVerseEnabled) {
    <div style="margin-top: 8px;">
      <div style="margin-bottom: 4px;">{{labelLinesPerVerse}}: {{data.currentLinesPerVerse}}</div>
      <mat-slider discrete
                  [min]="data.linesPerVerseMin ?? 1"
                  [max]="data.linesPerVerseMax ?? 7"
                  [step]="1"
      >
        <input matSliderThumb [(ngModel)]="data.currentLinesPerVerse" (ngModelChange)="onLinesPerVerseSliderChange()" />
      </mat-slider>
    </div>
  }

  @if (data.fonts?.length) {
    <mat-form-field appearance="fill" style="margin-top: 16px; width: 100%;">
      <mat-label>Font</mat-label>
      <mat-select [ngModel]="data.currentFontFamily ?? ''" (ngModelChange)="onFontChange($event || undefined)">
        <mat-option [value]="''">System Default</mat-option>
        <mat-option *ngFor="let f of (data.fonts || [])" [value]="f">
          <span [style.font-family]="f">{{f}}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  }

  @if (data.fontWeightEnabled) {
    <div style="margin-top: 8px;">
      <div style="margin-bottom: 4px;">{{labelFontWeight}}: {{data.currentFontWeight || 400}}</div>
      <mat-slider [min]="100" [max]="900" [step]="100">
        <input matSliderThumb [(ngModel)]="data.currentFontWeight" (ngModelChange)="onFontWeightChange()" />
      </mat-slider>
    </div>
  }

  @if (data.textOutlineToggleEnabled) {
    <div style="margin-top: 8px;">
      <mat-slide-toggle [ngModel]="data.textOutlineEnabled" (ngModelChange)="onTextOutlineToggle($event)">{{labelTextOutline}}</mat-slide-toggle>
    </div>
  }

  @if (data.textAlignmentEnabled) {
    <div style="margin-top: 8px;">
      <div style="margin-bottom: 4px;">{{labelAlignment}}</div>
      <mat-button-toggle-group [ngModel]="data.currentTextAlignment">
        <mat-button-toggle value="left" (click)="onTextAlignmentChange('left')"><mat-icon>format_align_left</mat-icon></mat-button-toggle>
        <mat-button-toggle value="center" (click)="onTextAlignmentChange('center')"><mat-icon>format_align_center</mat-icon></mat-button-toggle>
        <mat-button-toggle value="right" (click)="onTextAlignmentChange('right')"><mat-icon>format_align_right</mat-icon></mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  }
</div>
